module.exports = __webpack_public_path__ + "img/history3.51b29de2.jpg";